import { getCompressedFile } from "../shared/officeFileReader";
import { describeCompressedBytesUnavailable } from "../shared/compressedBytesSupport";

export const DOCX_MIME_TYPE =
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

/** The live document as .docx bytes. All the hard parts are in the shared reader. */
export function getDocumentAsDocx(onProgress?: (fraction: number) => void): Promise<Blob> {
  return getCompressedFile(DOCX_MIME_TYPE, onProgress);
}

/** Word cannot return compressed bytes on the web at all -- see the shared table. */
export function describeSaveUnavailable(): string | null {
  return describeCompressedBytesUnavailable("word");
}
